import { useRegulatoryListFilterValue } from "@stores/regulatoryList";

import {
  RegulatoryOrderingKey,
  RegulatoryOrderingValue,
} from "../Regulatory.types";

export const useGetRegulatoryListFilterData = () => {
  const regulatoryListFilter = useRegulatoryListFilterValue();
  const { search, page, pageLimit, status, order, classification } =
    regulatoryListFilter;

  const updateOrder = Object.entries(order).map(
    ([key, value]): {
      sortBy: RegulatoryOrderingKey;
      sortOrder: RegulatoryOrderingValue;
    } => ({
      sortBy: (key === "companyName"
        ? "company"
        : key) as RegulatoryOrderingKey,
      sortOrder: value as unknown as RegulatoryOrderingValue,
    }),
  );

  const regulatoryListFilterListForUpdate = {
    page,
    size: pageLimit,
    filter: {
      classification,
      draftArticleStatusHighest: status,
      ...(search && {
        search: Object.entries(search)
          .filter(([, value]) => value && value.trim() !== "")
          .map(([key, value]) => ({
            type: key === "companyNameInfo" ? "company" : key,
            keyword: value,
          })),
      }),
    },
    order: [...updateOrder],
  };

  return regulatoryListFilterListForUpdate;
};
